// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"29550c37","796":"933108f3"}[chunkId] + ".chunk.js";
};